var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-38588732-ebc4-4309-ab18-4b24538d71aa",
    "data-name": "uuid-adf45162-a364-4d8c-87ae-a3a6cab59c5a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1077.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e967a78a-d175-4e57-8ed9-80b38fef7b61",
    d: "M38.44,1075c-8.56,0-17.11-3.27-23.64-9.8-13.06-13.06-13.06-34.22,0-47.28L1017.92,14.8c13.06-13.06,34.22-13.06,47.28,0,13.06,13.06,13.06,34.22,0,47.28L62.08,1065.2c-6.53,6.53-15.09,9.8-23.64,9.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e967a78a-d175-4e57-8ed9-80b38fef7b61",
    d: "M847.14,1043.46c-109.32,0-198.24-88.95-198.24-198.27s88.92-198.21,198.24-198.21,198.24,88.88,198.24,198.21-88.92,198.27-198.24,198.27ZM847.14,713.85c-72.43,0-131.37,58.91-131.37,131.33s58.94,131.4,131.37,131.4,131.37-58.97,131.37-131.4-58.94-131.33-131.37-131.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e967a78a-d175-4e57-8ed9-80b38fef7b61",
    d: "M234.82,435.83c-109.32,0-198.24-88.88-198.24-198.21S125.49,39.42,234.82,39.42s198.24,88.88,198.24,198.21-88.92,198.21-198.24,198.21ZM234.82,106.29c-72.43,0-131.37,58.91-131.37,131.33s58.94,131.33,131.37,131.33,131.37-58.91,131.37-131.33-58.94-131.33-131.37-131.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricasIcon);
export default __webpack_public_path__ + "static/media/MetricasIcon.6c55830c3360712f6d0a3511b72f557a.svg";
export { ForwardRef as ReactComponent };